import type { PropsWithChildren } from 'react'

import { WithPopover } from '@procurify/ui'

import { type Currency } from '@webapp/models'
import { CurrencyConversionInfo } from '../CurrencyConversionInfo'
import { WithCurrencyConversionTooltipStyled } from './styles/WithCurrencyConversionTooltipStyled'

export interface IWithCurrencyConversionTooltipProps {
  currency: Currency
  price: number | string
  isDisabled?: boolean
}

export const WithCurrencyConversionTooltip = ({
  currency,
  price,
  isDisabled,
  children,
}: PropsWithChildren<IWithCurrencyConversionTooltipProps>) => {
  return (
    <WithPopover
      placement='top'
      isDisabled={isDisabled}
      content={
        <WithCurrencyConversionTooltipStyled>
          <CurrencyConversionInfo price={price} currency={currency} />
        </WithCurrencyConversionTooltipStyled>
      }
    >
      {children}
    </WithPopover>
  )
}

WithCurrencyConversionTooltip.displayName = 'WithCurrencyConversionTooltip'
